import { Component, OnInit } from "@angular/core";
import { RelatorioService } from "../../services/relatorio.services";

type Estado = "carregando" | "indisponivel" | "erro";

/**
 * Página de download do relatório SLA acessada a partir do link do e-mail
 * (rota /relatorios/sla/:ano/:mes/:dia). Não guarda o arquivo: pede ao
 * cliente-services uma URL pré-assinada de vida curta e navega para ela,
 * disparando o download direto do S3.
 *
 * O cliente é derivado do token no backend, então a data na URL apenas
 * identifica qual relatório baixar.
 */
@Component({
  selector: "mandae-relatorio-sla-download",
  templateUrl: "./sla-download.component.html",
  styleUrls: ["./sla-download.component.scss"]
})
export class SlaDownloadComponent implements OnInit {
  public estado: Estado = "carregando";

  constructor(public relatorioService: RelatorioService) {}

  public ngOnInit() {
    const data = this.extraiDataDaRota();

    if (!data) {
      this.estado = "erro";
      return;
    }

    // Self-guard: se não há sessão, guarda o destino e manda pro login.
    // O login reaplica a returnUrl ao voltar (login.controller.ts).
    if (!localStorage.getItem("ls.token")) {
      this.redirecionaParaLogin();
      return;
    }

    this.baixar(data.ano, data.mes, data.dia);
  }

  public tentarNovamente() {
    this.ngOnInit();
  }

  private async baixar(ano: string, mes: string, dia: string) {
    this.estado = "carregando";

    try {
      const resposta = await this.relatorioService.consultarLinkRelatorioSla(
        ano,
        mes,
        dia
      );

      if (resposta && resposta.url) {
        window.location.href = resposta.url;
        return;
      }

      this.estado = "indisponivel";
    } catch (err) {
      const status = err && err.status;

      if (status === 401 || status === 403) {
        // Token presente porém inválido/expirado: recomeça pelo login.
        this.redirecionaParaLogin();
      } else if (status === 404) {
        this.estado = "indisponivel";
      } else {
        this.estado = "erro";
      }
    }
  }

  private redirecionaParaLogin() {
    localStorage.setItem("ls.returnUrl", window.location.pathname);
    window.location.href = "/login";
  }

  /**
   * Extrai ano/mes/dia de /relatorios/sla/:ano/:mes/:dia. Usa o pathname
   * direto (html5Mode) para não depender da ponte de parâmetros ui.router →
   * componente downgraded.
   */
  private extraiDataDaRota(): { ano: string; mes: string; dia: string } | null {
    const partes = window.location.pathname.split("/").filter(Boolean);
    const i = partes.indexOf("sla");

    if (i === -1 || partes.length < i + 4) {
      return null;
    }

    const ano = partes[i + 1];
    const mes = partes[i + 2];
    const dia = partes[i + 3];

    if (!/^\d{4}$/.test(ano) || !/^\d{1,2}$/.test(mes) || !/^\d{1,2}$/.test(dia)) {
      return null;
    }

    return { ano, mes, dia };
  }
}
